var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToothbursh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 857,
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M573.48 888.712h-100.936v-306.9c0-27.872 22.596-50.468 50.468-50.468 27.872 0 50.468 22.596 50.468 50.468v306.9z",
    fill: "#A0D1F2",
    "p-id": 859
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M523.012 531.348c-5.152 0-10.12 0.78-14.804 2.216 20.648 6.328 35.664 25.532 35.664 48.252v306.896h29.604v-306.896c0.004-27.872-22.592-50.468-50.464-50.468z",
    fill: "#7BABF3",
    "p-id": 860
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M472.544 597.752h100.936v237.908h-100.936z",
    fill: "#FD919F",
    "p-id": 861
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M543.876 597.752h29.604v237.908h-29.604z",
    fill: "#E0667D",
    "p-id": 862
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M463.024 702.372h9.524v-65.928h-9.524a32.964 32.964 0 0 0-32.964 32.964 32.96 32.96 0 0 0 32.964 32.964z",
    fill: "#FD919F",
    "p-id": 863
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M523.012 531.348c7.448 0 14.5 1.656 20.864 4.552V117.956a20.864 20.864 0 0 0-41.728 0v417.944a50.244 50.244 0 0 1 20.864-4.552z",
    fill: "#D5E6F7",
    "p-id": 864
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M443.836 256.312h58.316V131.012h-58.316a13.776 13.776 0 0 0-13.776 13.776v97.752a13.772 13.772 0 0 0 13.776 13.772z",
    fill: "#FFFFFF",
    "p-id": 865
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M502.152 268.312h-58.316a25.8 25.8 0 0 1-25.776-25.772V144.788a25.804 25.804 0 0 1 25.776-25.776h58.316a12 12 0 0 1 12 12v125.3a12 12 0 0 1-12 12z m-58.316-125.3a1.776 1.776 0 0 0-1.776 1.776v97.752c0 0.976 0.796 1.772 1.776 1.772h46.316V143.012h-46.316z",
    fill: "#504774",
    "p-id": 866
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M574.844 926.904h-103.664a19.092 19.092 0 1 1 0-38.192h103.664a19.092 19.092 0 1 1 0 38.192z",
    fill: "#7BABF3",
    "p-id": 867
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M543.876 547.904c-1.692 0-3.388-0.356-4.972-1.08a38.2 38.2 0 0 0-31.776 0 12.008 12.008 0 0 1-16.972-10.92V117.956c0-18.12 14.744-32.864 32.86-32.864 18.12 0 32.864 14.744 32.864 32.864v417.944a12 12 0 0 1-12.004 12.004z m-20.864-28.556c2.984 0 5.94 0.212 8.864 0.632V117.956c0-4.888-3.976-8.864-8.864-8.864s-8.86 3.976-8.86 8.864v402.024a62.224 62.224 0 0 1 8.86-0.632z",
    fill: "#504774",
    "p-id": 868
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M573.48 900.716h-100.932a12 12 0 0 1-12-12v-306.9c0-34.444 28.024-62.468 62.464-62.468 34.444 0 62.468 28.024 62.468 62.468v306.9a12 12 0 0 1-12 12z m-88.932-24h76.932v-294.9c0-21.212-17.256-38.468-38.468-38.468s-38.464 17.256-38.464 38.468v294.9z",
    fill: "#504774",
    "p-id": 869
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M574.844 938.908h-103.664c-17.144 0-31.092-13.948-31.092-31.096 0-17.144 13.948-31.092 31.092-31.092h103.664c17.148 0 31.096 13.948 31.096 31.092s-13.948 31.096-31.096 31.096z m-103.664-38.192c-3.912 0-7.092 3.184-7.092 7.092 0 3.916 3.184 7.096 7.092 7.096h103.664c3.916 0 7.096-3.184 7.096-7.096s-3.184-7.092-7.096-7.092h-103.664zM472.548 714.376h-9.524c-24.792 0-44.964-20.172-44.964-44.964s20.172-44.96 44.964-44.96h9.524a12 12 0 0 1 12 12v65.924a12 12 0 0 1-12 12z m-12-65.784a20.992 20.992 0 0 0-18.488 20.816 20.996 20.996 0 0 0 18.488 20.82v-41.636z",
    fill: "#504774",
    "p-id": 870
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M573.48 847.66h-100.932a12 12 0 0 1-12-12v-237.912a12 12 0 0 1 12-12h100.932a12 12 0 0 1 12 12v237.912a12 12 0 0 1-12 12z m-88.932-24h76.932v-213.912h-76.932v213.912zM502.152 184.644h-72.092a12 12 0 1 1 0-24h72.092a12 12 0 1 1 0 24zM502.152 226.684h-72.092a12 12 0 1 1 0-24h72.092a12 12 0 1 1 0 24z",
    fill: "#504774",
    "p-id": 871
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothbursh);
export default __webpack_public_path__ + "static/media/toothbursh.098af4385370246aa181c6c57ed9f449.svg";
export { ForwardRef as ReactComponent };